import { createPersistedStore, storage } from '@connect-x-app/hybrid-utils';
import { Preferences, SettingsItems, ThemePreference, TimeZone } from '@connect-x-app/shared-domain-models';
import { createJSONStorage } from 'zustand/middleware';

// What `setSettings` merges into the store: the push settings and the preferences it is given, the rest unchanged.
export type SettingsUpdate = Partial<Omit<SettingsItems, 'preferences'>> & { preferences?: Partial<Preferences> };

type SettingsState = {
  setSettings: (settings: SettingsUpdate) => void;
  setThemePreference: (themePreference: ThemePreference) => void;
  settings: SettingsItems;
};

export const useSettingsStore = createPersistedStore<SettingsState>(
  (set, _) => ({
    setSettings: settings => {
      set(state => ({
        settings: {
          ...state.settings,
          ...settings,
          preferences: {
            ...state.settings.preferences,
            ...(settings?.preferences ?? {}),
          },
        },
      }));
    },
    setThemePreference: themePreference => {
      set(state => ({
        settings: {
          ...state.settings,
          preferences: {
            ...state.settings?.preferences,
            themePreference,
          },
        },
      }));
    },
    settings: {
      preferences: { themePreference: ThemePreference.SYSTEM, timeZone: TimeZone.UTC },
      pushNotifications: [],
    },
  }),
  {
    name: 'settings-store',
    storage: createJSONStorage(() => storage),
  },
);
